/**
 * Shared colour defaults for the trading-analytics chart components
 * (CandlestickChart, DailyPnLBarChart, Histogram, ScatterWithTrendline).
 *
 * These mirror the Style Guide's existing up/down signal tokens
 * (`--capital-up` / `--capital-down` in src/index.scss) rather than
 * inventing a second green/red — every value here has a token equivalent.
 * Chrome that isn't data-driven (gridlines, axis text, chart background)
 * stays in each component's .scss file as `var(--hairline)` /
 * `var(--text-muted)` / `var(--bg-surface)`, same as LineChart.
 */
export const CHART_COLORS = {
  up: '#22c55e', // == var(--capital-up)
  down: '#fd4754', // == var(--capital-down)
  info: '#6ea8ff', // == var(--chip-info-text) — used where the design calls for blue
  warning: '#f7d774', // == var(--warning-text) — a limit that isn't the hard floor (max daily loss)
  neutral: '#777777', // == var(--text-muted)
  distribution: '#7b8dff', // no existing token — Histogram's bell-curve node (1:26329) introduces this indigo
};

export const CHART_TRENDLINE_COLOR = 'rgba(255, 255, 255, 0.05)'; // == var(--hairline)

export const CHART_REGION_FILL = 'rgba(120, 30, 30, 0.15)';
